export type PlayerVehicleId = 'sprinter' | 'hiace' | 'vitz';

export interface PlayerVehicle {
  id: PlayerVehicleId;
  name: string;
  blurb: string;
  capacity: number;
  sticker: string;
}

export const PLAYER_VEHICLES: Record<PlayerVehicleId, PlayerVehicle> = {
  sprinter: { id: 'sprinter', name: 'Sprinter', blurb: 'Big high-roof · 18 seats', capacity: 18, sticker: 'GOD NEVER FAILS' },
  hiace: { id: 'hiace', name: 'Toyota "Fish"', blurb: 'Nimble HiAce · 15 seats', capacity: 15, sticker: 'SEA NEVER DRY' },
  vitz: { id: 'vitz', name: 'Toyota Vitz', blurb: 'Small saloon · 4 seats', capacity: 4, sticker: 'SMALL BUT MIGHTY' },
};
